export default {
  app: {
    name: "Sportsbook",
    full: "Back Office Template",
    minimized: "BO"
  },
  no_records: "No records",
  welcome: "Chào mừng trở lại, {user}!",
  login: "đăng nhập",
  login_success: "Đăng nhập thành công",
  relogin: "Vui lòng đăng nhập lại vào tài khoản của bạn.",
  expired: "Bạn đã đăng xuất do nhiều lần đăng nhập!",
  denied: "Quyền bị từ chối!",
  success: "Bạn đã hoàn thành thành công!",
  select_date_range: "Vui lòng chọn một ngày",
  permission_denied: "Bạn không được phép thực hiện hành động này!",
  search_by_id_name: "Tìm kiếm theo ID hoặc Tên",
  search_by_name: "Tìm kiếm theo tên",
  close: "Tài khoản đã đóng. Vui lòng liên hệ với quản trị viên của bạn.",
  suspend: "toàn khoản bị đình chỉ. Vui lòng liên hệ với quản trị viên của bạn.",
  suspend_alert1: "Tài khoản của bạn đã được thay đổi thành \"Chỉ xem\".",
  suspend_alert2: "Vui lòng tham khảo Upline của bạn.",
  freeze: "tài khoản bị đóng băng. Vui lòng liên hệ với quản trị viên của bạn.",
  account_id_length_error: "Độ dài id tài khoản không hợp lệ",
  change_user_status_confirm: "Bạn có chắc chắn muốn thay đổi trạng thái Tài khoản?",
  delete_confirm: "Bạn có chắc chắn muốn xóa \"{name}\"?",
  update_account_status_confirm: "Bạn có chắc chắn muốn cập nhật trạng thái tài khoản?",
  update_account_status_cancel: "Cập nhật trạng thái tài khoản không thành công.",
  update_account_status_success: "Tình trạng tài khoản được cập nhật thành công!",
  update_account_password_confirm: "Bạn có chắc chắn muốn cập nhật mật khẩu tài khoản của mình?",
  update_account_password_cancel: "Cập nhật mật khẩu tài khoản không thành công.",
  update_account_password_success: "Đã cập nhật mật khẩu thành công!",
  update_account_security_confirm: "Bạn có chắc chắn muốn cập nhật bảo mật tài khoản?",
  update_account_security_cancel: "Cập nhật bảo mật tài khoản không thành công.",
  update_account_security_success: "Bảo mật tài khoản được cập nhật thành công!",
  update_account_authority_confirm: "Bạn có chắc chắn muốn cập nhật thẩm quyền tài khoản?",
  update_account_authority_cancel: "Cập nhật thẩm quyền tài khoản không thành công.",
  update_account_authority_success: "Quyền tài khoản được cập nhật thành công!",
  block_sub_account_confirm: "Bạn có chắc chắn muốn chặn tài khoản phụ?",
  block_sub_account_cancel: "Khối tài khoản phụ không thành công.",
  block_sub_account_success: "Tài khoản phụ bị chặn thành công!",
  unblock_sub_account_confirm: "Bạn có chắc chắn muốn bỏ chặn tài khoản phụ?",
  unblock_sub_account_cancel: "Bỏ chặn tài khoản phụ không thành công.",
  unblock_sub_account_success: "Tài khoản phụ đã được bỏ chặn thành công!",
  successful_update_profile: "Bạn đã cập nhật thành công hồ sơ của bạn.",
  successful_update_security: "Bạn đã cập nhật thành công mã bảo mật.",
  successful_create_account: "Bạn đã tạo thành công một tài khoản mới. ",
  update_platform_settings_confirm: "Bạn có chắc chắn muốn cập nhật cài đặt nền tảng?",
  update_platform_settings_cancel: "Cập nhật cài đặt nền tảng không thành công.",
  update_platform_settings_success: "Cài đặt nền tảng cập nhật thành công!",
  reset_accumulate_win_confirm: "Bạn có chắc chắn muốn thiết lập lại giới hạn tích lũy?",
  reset_accumulate_win_cancel: "Đặt lại tích lũy giới hạn chiến thắng không thành công.",
  reset_accumulate_win_success: "Tích trữ giới hạn thắng thiết lập lại thành công!",
  parent_platform_disabled: "Cài đặt nền tảng đường lên đã bị vô hiệu hóa.",
  copy_success: "Thông tin tài khoản đã được sao chép vào clipboard.",
  copy_failed: "Trình duyệt của bạn không hỗ trợ sao chép vào clipboard.",
  copy_all_upline: "Sao chép Bóng Đá HDP đại lý tuyến trê lớn tất cả thể thao",
  copy_all_account: "Sao chép Bóng Đá HDP tất cả thể thao Tài Khoản",
  copy_all_remaining: "Sao chép Bóng Đá HDP tất cả thể Còn lại",
  copy_all_min: "Sao chép Bóng Đá HDP PT Đặt tất cả",
  copy_all_min_bet: "Sao chép Bóng Đá Đặt tất cả thể cược tối thiểu",
  copy_all_max_bet: "Sao chép Bóng Đá Đặt tất cả thể Đặt Cược Tối Đa",
  copy_all_max_per_match: "Sao chép Bóng Đá tất cả thể Tối Đa Cho Mỗi Trận",
  create_secondary_account_success: "Tài khoản phụ đã được tạo thành công! Xin vui lòng đăng nhập lại.",
  first_sub_account_success: "Tài khoản phụ được cập nhật thành công! Xin vui lòng đăng nhập lại.",
  update_account_commission_confirm: "Bạn có chắc chắn muốn cập nhật hoa hồng tài khoản?",
  update_account_commission_cancel: "Cập nhật hoa hồng tài khoản không thành công.",
  update_account_commission_success: "Hoa hồng tài khoản được cập nhật thành công!",
  update_account_position_confirm: "Bạn có chắc chắn muốn cập cấp độ tài khoản?",
  update_account_position_cancel: "muốn cập Tài Khoản cấp độ Thất bại.",
  update_account_position_success: "Vị trí tài khoản được cập nhật sự thành công!",
  update_account_bet_limit_confirm: "Bạn có chắc chắn muốn cập nhật giới hạn đặt cược tài khoản của mình không?",
  update_account_bet_limit_cancel: "Không thể cập nhật giới hạn đặt cược tài khoản.",
  update_account_bet_limit_success: "Giới hạn đặt cược tài khoản đã được cập nhật thành công!",
  update_account_profile_confirm: "Bạn có chắc chắn muốn cập nhật hồ sơ tài khoản?",
  update_account_profile_cancel: "Không thể cập nhật hồ sơ tài khoản.",
  update_account_profile_success: "Hồ sơ tài khoản được cập nhật thành công!",
  create_new_account_confirm: "Bạn có chắc chắn muốn tạo một tài khoản mới?",
  create_new_account_cancel: "Tạo một tài khoản mới không thành công",
  create_new_account_success: "Tài khoản mới được tạo thành công!",
  create_sub_account_confirm: "Bạn có chắc chắn muốn tạo một tài khoản phụ?",
  create_sub_account_cancel: "Tạo tài khoản phụ không thành công",
  create_sub_account_success: "Tài khoản phụ đã được tạo thành công!",
  update_sub_account_confirm: "Bạn có chắc chắn muốn cập nhật tài khoản phụ?",
  update_sub_account_cancel: "Cập nhật phụ không thành công",
  update_sub_account_success: "Tài khoản phụ được cập nhật thành công!",
  unblock_account_profile_confirm: "Bạn có chắc chắn muốn bỏ chặn hồ sơ tài khoản?",
  unblock_account_profile_cancel: "Bỏ chặn hồ sơ tài khoản không thành công.",
  unblock_account_profile_success: "Hồ sơ tài khoản đã được bỏ chặn thành công!",
  settlement_confirm: "Bạn có chắc chắn muốn tiến hành giải quyết?",
  settlement_cancel: "giải quyết thất bại",
  settlement_success: "Giải quyết thành công!",
  settlement_not_allowed: "Giải quyết không được phép ngày hôm nay!",
  search_with_working_date: "Tìm kiếm với ngày làm việc",
  system_error: "Hệ thống không thể xử lý yêu cầu của bạn.",
  invalid_password: "Sai Tên người sử dụng hoặc Mật khẩu.",
  invalid_account: "Tài khoản này không hợp lệ.",
  block: "Tài khoản của bạn đã bị khóa.",
  invalid_security_code: "Mã bảo mật không hợp lệ.",
  source_account_id_required: "ID tài khoản là bắt buộc.",
  target_account_id_required: "ID tài khoản mục tiêu là bắt buộc.",
  account_id_required: "ID tài khoản là bắt buộc.",
  sub_login_id_required: "ID đăng nhập là bắt buộc.",
  account_not_exists: "Tài khoản này không hợp lệ.",
  profile_not_exists: "Tài khoản này không hợp lệ.",
  account_inactive: "Tài khoản không hoạt động.",
  not_blocked_account: "Tài Khoản Có thể sử dụng.",
  password_required: "Mật khẩu là bắt buộc.",
  parent_id_required: "ID phụ huynh là bắt buộc.",
  parent_not_exists:"Tài khoản này không hợp lệ.",
  invalid_account_type: "Loại tài khoản không hợp lệ.",
  account_exists: "Tài khoản đã tồn tại.",
  login_id_required: "ID đăng nhập là bắt buộc.",
  new_login_id_required: "ID đăng nhập mới là bắt buộc.",
  login_id_not_exists: "ID đăng nhập không hợp lệ.",
  invalid_authority_role: "Vai trò không hợp lệ.",
  profile_inactive: "Hồ sơ không hợp lệ.",
  secondary_account_exists: "Tài khoản phụ đã tồn tại.",
  new_login_id_exists: "ID đăng nhập mới đã tồn tại.",
  new_password_required: "Mật khẩu mới là bắt buộc.",
  security_tag_required: "Thẻ bảo mật bắt buộc",
  security_code_required: "Mã bảo mật là bắt buộc.",
  start_date_required: "Ngày bắt đầu là bắt buộc.",
  end_date_required: "Ngày kết thúc là bắt buộc.",
  start_date_gt_end_date: "Ngày bắt đầu lớn hơn ngày kết thúc.",
  start_date_greater_end_date: "Ngày bắt đầu lớn hơn ngày kết thúc.",
  member_id_required: "ID thành viên là bắt buộc.",
  currency_code_required: "Mã tiền tệ là bắt buộc.",
  commission_setting_not_exists: "Thiết lập hoa hồng không tồn tại.",
  incomplete_account_line: "Dòng tài khoản không đầy đủ.",
  invalid_hdp_package: "Gói HDP không hợp lệ.",
  search_id_required: "ID tìm kiếm là bắt buộc.",
  profile_id_required: "ID hồ sơ là bắt buộc.",
  login_not_exists: "ID đăng nhập không hợp lệ.",
  no_changes: "Không có thay đổi được phát hiện.",
  start_date_require: "Ngày bắt đầu là bắt buộc.",
  league_id_required: "liên đoàn ID is required.",
  sport_type_required: "Loại hình thể thao là bắt buộc.",
  match_id_required: "giải đấu ID is required.",
  target_login_id_required: "ID đăng nhập mục tiêu là bắt buộc.",
  parent_account_not_exists: "Tài khoản này không hợp lệ.",
  parent_account_inactive: "Tài khoản phụ huynh không hoạt động.",
  parent_profile_not_exists: "Tài khoản này không hợp lệ ..",
  parent_profile_inactive: "Hồ sơ phụ huynh không hoạt động.",
  target_login_id_not_exists: "Tài khoản này không hợp lệ.",
  incorrect_parent: "ID cha không hợp lệ.",
  invalid_session: "Yêu cầu phiên không hợp lệ.",
  session_expired: "Phiên hết hạn.",
  settle_amount_required: "phải giải quyết số tiền.",
  invalid_settle_amount: "Số tiền giải quyết không hợp lệ.",
  settle_amount_gt_yesterday_balance: "Số tiền thanh toán lớn hơn số dư của ngày hôm qua.",
  invalid_account_status: "Trạng thái tài khoản không hợp lệ.",
  bet_limit_packages_required: "Các gói giới hạn đặt cược là bắt buộc.",
  bet_limit_exists: "Giới hạn cá cược đã tồn tại.",
  member_bet_limit_package_gt_one: "Gói giới hạn đặt cược thành viên là nhiều hơn một.",
  parent_bet_limit_not_exists: "Giới hạn đặt cược của cha mẹ không tồn tại.",
  account_commission_required: "Hoa hồng tài khoản là bắt buộc.",
  commission_setting_exists: "Thiết lập hoa hồng đã tồn tại.",
  parent_comm_not_exists: "đại lý tuyến trên cHoa hồng Xác lập does not exits.",
  exceeded_parent_comm: "Vượt quá đại lý tuyến trên Hoa hồng Xác lập.",
  others_commission_required: "Các cài đặt hoa hồng khác là bắt buộc.",
  exceeded_parent_1x2: "Vượt quá đại lý tuyến trên 1x2 Hoa hồng Xác lập.",
  exceeded_parent_other: "Vượt quá đại lý tuyến trên other Hoa hồng Xác lập.",
  hdp_commission_required: "HDP Hoa hồng Xác lập Cần.",
  exceeded_parent_hdp_a: "Vượt quá HPD(A) Hoa hồng Xác lập.",
  exceeded_parent_hdp_b: "Vượt quá HPD(B) Hoa hồng Xác lập.",
  exceeded_parent_hdp_c: "Vượt quá HPD(C) Hoa hồng Xác lập.",
  exceeded_parent_hdp_d: "Vượt quá HPD(D) Hoa hồng Xác lập.",
  exceeded_parent_hdp_e: "Vượt quá HPD(E) Hoa hồng Xác lập.",
  exceeded_parent_hdp_f: "Vượt quá HPD(F) Hoa hồng Xác lập.",
  exceeded_parent_hdp_g: "Vượt quá HPD(G) Hoa hồng Xác lập.",
  exceeded_parent_hdp_h: "Vượt quá HPD(H) Hoa hồng Xác lập.",
  exceeded_parent_hdp_i: "Vượt quá HPD(I) Hoa hồng Xác lập.",
  exceeded_parent_hdp_j: "Vượt quá HPD(J) Hoa hồng Xác lập.",
  livecasino_upline_pt_required: "[Sòng Bài Live] PT đại lý tuyến trên nhu cầu.",
  livecasino_pt_setting_exists: "[Sòng Bài Live] Xác lập đại lý tuyến trên PT tồn tại.",
  livecasino_parent_pt_not_exists: "[Sòng Bài Live] đại lý tuyến trên PT nhu cầu Không tồn tại.",
  livecasino_parent_min_not_meet: "[Sòng Bài Live] đại lý tuyến trên tối thiểu PT Không được phép .",
  livecasino_exceeded_parent_pt: "[Sòng Bài Live] PT đại lý tuyến trên Xác lập thêm .",
  livecasino_account_pt_required: "[Sòng Bài Live] Tài Khoản PT Xác lập Cần.",
  livecasino_upline_remaining_required: "[Sòng Bài Live] đại lý tuyến trên remaining Xác lập Cần.",
  livecasino_account_min_required: "[Sòng Bài Live] Tài Khoản Đặt cược tối thiểu Xác lập Cần.",
  livecasino_upline_remaining_gt_account_pt: "[Sòng Bài Live] đại lý tuyến trên PT Xác lập thêm Tài Khoản PT Xác lập.",
  livecasino_account_min_gt_p: "[Sòng Bài Live] Tài Khoản tối thiểu PT Xác lập thêm đại lý tuyến trên PT Xác lập.",
  slots_upline_pt_required: "[Trò Chơi Sòng Bài] Xác lập đại lý tuyến trên PT tồn tại.",
  slots_pt_setting_exists: "[Trò Chơi Sòng Bài] PT Xác lập tồn tại.",
  slots_parent_pt_not_exists: "[Trò Chơi Sòng Bài] đại lý tuyến trên PT nhu cầu Không tồn tại.",
  slots_parent_min_not_meet: "[Trò Chơi Sòng Bài] đại lý tuyến trên tối thiểu PT Không được phép.",
  slots_exceeded_parent_pt: "[Trò Chơi Sòng Bài] PT đại lý tuyến trên Xác lập thêm.",
  slots_account_pt_required: "[Trò Chơi Sòng Bài] PT Tài Khoản Xác lập Cần.",
  slots_upline_remaining_required: "[Trò Chơi Sòng Bài] đại lý tuyến trên remaining Xác lập Cần.",
  slots_account_min_required: "[Trò Chơi Sòng Bài] Tài Khoản Đặt cược tối thiểu Xác lập Cần.",
  slots_upline_remaining_gt_account_pt: "[Trò Chơi Sòng Bài] đại lý tuyến trên PT Xác lập thêm Tài Khoản PT Xác lập.",
  slots_account_min_gt_pt: "[Trò Chơi Sòng Bài] Tài Khoản tối thiểu PT Xác lập thêm đại lý tuyến trên PT Xác lập.",
  lotto_upline_pt_required: "[Lotto] Xác lập đại lý tuyến trên PT tồn tại.",
  lotto_pt_setting_exists: "[Lotto] PT Xác lập tồn tại.",
  lotto_parent_pt_not_exists: "[Lotto] đại lý tuyến trên PT nhu cầu Không tồn tại.",
  lotto_parent_min_not_meet: "[Lotto] đại lý tuyến trên tối thiểu PT Không được phép.",
  lotto_exceeded_parent_pt: "[Lotto] PT đại lý tuyến trên Xác lập thêm.",
  lotto_account_pt_required: "[Lotto] PT Tài Khoản Xác lập Cần.",
  lotto_upline_remaining_required: "[Lotto] đại lý tuyến trên remaining Xác lập Cần.",
  lotto_account_min_required: "[Lotto] Tài Khoản Đặt cược tối thiểu Xác lập Cần.",
  lotto_upline_remaining_gt_account_pt: "[Lotto] đại lý tuyến trên PT Xác lập thêm Tài Khoản PT Xác lập.",
  lotto_account_min_gt_pt: "[Lotto] Tài Khoản tối thiểu PT Xác lập thêm đại lý tuyến trên PT Xác lập.",
  keno_upline_pt_required: "[Keno] Xác lập đại lý tuyến trên PT tồn tại.",
  keno_pt_setting_exists: "[Keno] PT Xác lập tồn tại.",
  keno_parent_pt_not_exists: "[Keno] đại lý tuyến trên PT nhu cầu Không tồn tại.",
  keno_parent_min_not_meet: "[Keno] đại lý tuyến trên tối thiểu PT Không được phép.",
  keno_exceeded_parent_pt: "[Keno] PT đại lý tuyến trên Xác lập thêm.",
  keno_account_pt_required: "[Keno] PT Tài Khoản Xác lập Cần.",
  keno_upline_remaining_required: "[Keno] đại lý tuyến trên remaining Xác lập Cần.",
  keno_account_min_required: "[Keno] Tài Khoản Đặt cược tối thiểu Xác lập Cần.",
  keno_upline_remaining_gt_account_pt: "[Keno] đại lý tuyến trên PT Xác lập thêm Tài Khoản PT Xác lập.",
  keno_account_min_gt_pt: "[Keno] Tài Khoản tối thiểu PT Xác lập thêm đại lý tuyến trên PT Xác lập.",
  cockfight_upline_pt_required: "[THỂ THAO ĐIỆN TỬ Hai] Xác lập đại lý tuyến trên PT tồn tại.",
  cockfight_pt_setting_exists: "[THỂ THAO ĐIỆN TỬ Hai] PT Xác lập tồn tại.",
  cockfight_parent_pt_not_exists: "[THỂ THAO ĐIỆN TỬ Hai] đại lý tuyến trên PT nhu cầu Không tồn tại.",
  cockfight_parent_min_not_meet: "[THỂ THAO ĐIỆN TỬ Hai] đại lý tuyến trên tối thiểu PT Không được phép.",
  cockfight_exceeded_parent_pt: "[THỂ THAO ĐIỆN TỬ Hai] PT đại lý tuyến trên Xác lập thêm.",
  cockfight_account_pt_required: "[THỂ THAO ĐIỆN TỬ Hai] PT Tài Khoản Xác lập Cần.",
  cockfight_upline_remaining_required: "[THỂ THAO ĐIỆN TỬ Hai] đại lý tuyến trên remaining Xác lập Cần.",
  cockfight_account_min_required: "[THỂ THAO ĐIỆN TỬ Hai] Tài Khoản Đặt cược tối thiểu Xác lập Cần.",
  cockfight_upline_remaining_gt_account_pt: "[THỂ THAO ĐIỆN TỬ Hai] đại lý tuyến trên PT Xác lập thêm Tài Khoản PT Xác lập.",
  cockfight_account_min_gt_pt: "[THỂ THAO ĐIỆN TỬ Hai] Tài Khoản tối thiểu PT Xác lập thêm đại lý tuyến trên PT Xác lập.",
  cockfight_exceeded_parent_commission: "[THỂ THAO ĐIỆN TỬ Hai] Cài đặt hoa hồng tài khoản lớn hơn cài đặt hoa hồng gốc.",
  lottery_upline_pt_required: "[Xổ số] Xác lập đại lý tuyến trên PT tồn tại.",
  lottery_pt_setting_exists: "[Xổ số] PT Xác lập tồn tại.",
  lottery_parent_pt_not_exists: "[Xổ số] đại lý tuyến trên PT nhu cầu Không tồn tại.",
  lottery_parent_min_not_meet: "[Xổ số] đại lý tuyến trên tối thiểu PT Không được phép.",
  lottery_exceeded_parent_pt: "[Xổ số] PT đại lý tuyến trên Xác lập thêm.",
  lottery_account_pt_required: "[Xổ số] PT Tài Khoản Xác lập Cần.",
  lottery_upline_remaining_required: "[Xổ số] đại lý tuyến trên remaining Xác lập Cần.",
  lottery_account_min_required: "[Xổ số] Tài Khoản Đặt cược tối thiểu Xác lập Cần.",
  lottery_upline_remaining_gt_account_pt: "[Xổ số] đại lý tuyến trên PT Xác lập thêm Tài Khoản PT Xác lập.",
  lottery_account_min_gt_pt: "[Xổ số] Tài Khoản tối thiểu PT Xác lập thêm đại lý tuyến trên PT Xác lập.",
  bet_type_required: "Lọai cược nhu cầu",
  schedule_1_to_7_required: "Thanh toán Ngày nhu cầu",
  schedule_exists: "Thanh toán Ngày nhu cầu tồn tại.",
  parent_schedule_not_exists: "Thanh toán đại lý tuyến trên Ngày nhu cầu Không tồn tại.",
  schedule_1_not_available: "Thứ hai Thanh toán không cho phép.",
  schedule_2_not_available: "Thứ ba Thanh toán không cho phép.",
  schedule_3_not_available: "Thứ tư Thanh toán không cho phép.",
  schedule_4_not_available: "Thứ năm Thanh toán không cho phép.",
  schedule_5_not_available: "Thứ sáu Thanh toán không cho phép.",
  schedule_6_not_available: "Thứ bảy Thanh toán không cho phép.",
  schedule_7_not_available: "Chủ nhật Thanh toán  không cho phép.",
  credit_limit_required: "Giới Hạn Tín Dụng Cần.",
  member_credit_limit_required: "Tín Dụng Thành Viên Cần.",
  wallet_exists: "Tín Dụng tồn tại.",
  member_credit_limit_gt_credit_limit: "Tín Dụng Thành Viên Vượt quá Tín Dụng.",
  parent_wallet_not_exists: "đại lý tuyến trên Tín Dụng không tồn tại.",
  account_credit_limit_gt_parent: "Tín Dụng Tài Khoản Vượt quá đại lý tuyến trên .",
  member_credit_limit_gt_parent: "Tín Dụng Thành Viên Vượt quá đại lý tuyến trên",
  exceeded_credit_limit: "Vượt quá Tín Dụng.",
  soccer_min_bet_required: "Bóng Đá Đặt cược tối thiểu Cần .",
  soccer_max_bet_required: "Bóng Đá Đặt Cược Tối Đa Cần.",
  soccer_max_per_match_required: "Bóng Đá Tối Đa Cho Mỗi Trận Cần.",
  soccer_bet_limit_exists: "Bóng Đá Giới hạn cá cược tồn tại.",
  soccer_parent_bet_limit_not_exists: "Bóng Đá đại lý tuyến trên Giới hạn cá cược không tồn tại.",
  soccer_account_min_bet_lt_parent: "Bóng Đá Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  soccer_account_max_bet_gt_parent: "Bóng Đá Đặt Cược Tối Đa Tín Vượt quá đại lý tuyến trên",
  soccer_account_max_per_match_gt_parent: "Bóng Đá Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  basketball_min_bet_required: "Bóng Rổ Đặt cược tối thiểu Cần.",
  basketball_max_bet_required: "Bóng Rổ Đặt Cược Tối Đa Cần.",
  basketball_max_per_match_required: "Bóng Rổ Maximum bet per match is required",
  basketball_bet_limit_exists: "Bóng Rổ Tối Đa Cho Mỗi Trận Cần.",
  basketball_parent_bet_limit_not_exists: "Bóng Rổ Parent bet limit does not exists.",
  basketball_account_min_bet_lt_parent: "Bóng Rổ Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  basketball_account_max_bet_gt_parent: "Bóng Rổ Cược Tối Đa Tín Vượt quá đại lý tuyến trên",
  basketball_account_max_per_match_gt_parent: "Bóng Rổ Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  tennis_min_bet_required: "Quần Vợt Đặt cược tối thiểu Cần.",
  tennis_max_bet_required: "Quần Vợt Đặt Cược Tối Đa Cần.",
  tennis_max_per_match_required: "Quần Vợt Tối Đa Cho Mỗi Trận Cần",
  tennis_bet_limit_exists: "Quần Vợt Giới hạn cá cược tồn tại.",
  tennis_parent_bet_limit_not_exists: "Quần Vợt đại lý tuyến trên Giới hạn cá cược không tồn tại.",
  tennis_account_min_bet_lt_parent: "Quần Vợt Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  tennis_account_max_bet_gt_parent: "Quần Vợt Đặt Cược Tối Đa Tín Vượt quá đại lý tuyến trên",
  tennis_account_max_per_match_gt_parent: "Quần Vợt Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  baseball_min_bet_required: "Bóng Chày Đặt cược tối thiểu Cần.",
  baseball_max_bet_required: "Bóng Chày Đặt Cược Tối Đa Cần.",
  baseball_max_per_match_required: "Bóng Chày Tối Đa Cho Mỗi Trận Cần",
  baseball_bet_limit_exists: "Bóng Chày Giới hạn cá cược tồn tại.",
  baseball_parent_bet_limit_not_exists: "Bóng Chày đại lý tuyến trên Giới hạn cá cược không tồn tại.",
  baseball_account_min_bet_lt_parent: "Bóng Chày Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  baseball_account_max_bet_gt_parent: "Bóng Chày Đặt Cược Tối Đa Tín Vượt quá đại lý tuyến trên",
  baseball_account_max_per_match_gt_parent: "Bóng Chày Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  parlay_min_bet_required: "Đặt Cựơc Dồn Vợt Đặt cược tối thiểu Cần.",
  parlay_max_bet_required: "Đặt Cựơc Dồn Đặt Cược Tối Đa Cần.",
  parlay_max_per_match_required: "Đặt Cựơc Dồn Tối Đa Cho Mỗi Trận Cần",
  parlay_bet_limit_exists: "Đặt Cựơc Dồn Giới hạn cá cược tồn tại.",
  parlay_parent_bet_limit_not_exists: "Đặt Cựơc Dồn đại lý tuyến trên Giới hạn cá cược không tồn tại.",
  parlay_account_min_bet_lt_parent: "Đặt Cựơc Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  parlay_account_max_bet_gt_parent: "Đặt Cựơc Dồn Cược Tối Đa Tín Vượt quá đại lý tuyến trên",
  parlay_account_max_per_match_gt_parent: "Đặt Cựơc Dồn Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  esports_min_bet_required: "Thể thao điện tử Dồn Vợt Đặt cược tối thiểu Cần.",
  esports_max_bet_required: "Thể thao điện tử Đặt Cược Tối Đa Cần.",
  esports_max_per_match_required: "Thể thao điện tử Tối Đa Cho Mỗi Trận Cần",
  esports_bet_limit_exists: "Thể thao điện tử Giới hạn cá cược tồn tại.",
  esports_parent_bet_limit_not_exists: "Thể thao điện tử đại lý tuyến trên Giới hạn cá cược không tồn tại.",
  esports_account_min_bet_lt_parent: "Thể thao điện tử Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  esports_account_max_bet_gt_parent: "Thể thao điện tử Cược Tối Đa Tín Vượt quá đại lý tuyến trên.",
  esports_account_max_per_match_gt_parent: "Thể thao điện tử Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  others_min_bet_required: "Thể loại khác Dồn Vợt Đặt cược tối thiểu Cần.",
  others_max_bet_required: "Thể loại khác Đặt Cược Tối Đa Cần.",
  others_max_per_match_required: "Thể loại khác Tối Đa Cho Mỗi Trận Cần",
  others_bet_limit_exists: "Thể loại khác Giới hạn cá cược tồn tại.",
  others_parent_bet_limit_not_exists: "Thể loại khác đại lý tuyến trên Giới hạn cá cược không tồn tại.",
  others_account_min_bet_lt_parent: "Thể loại khác Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  others_account_max_bet_gt_parent: "Thể loại khác Cược Tối Đa Tín Vượt quá đại lý tuyến trên",
  others_account_max_per_match_gt_parent: "Thể loại khác Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  used_credit_gt_credit_limit: "Tín dụng đã qua sử dụng Vượt quá Tín Dụng Giới Hạn.",
  bet_limit_setting_not_exists: "Giới Hạn Cược Xác lập không tồn tại.",
  parent_bet_limit_setting_not_exists: "đại lý tuyến trên Giới Hạn Cược Xác lập không tồn tại .",
  package_not_exists_in_parent: "đại lý tuyến trên Giới Hạn Cược gói Xác lập không tồn tại",
  soccer_bet_limit_setting_not_exists: "Bóng Đá Giới Hạn Cược Xác lập không tồn tại.",
  soccer_update_interval_violated: "Bóng Đá Cập nhật vi phạm khoảng .",
  basketball_bet_limit_setting_not_exists: "Bóng Rổ Giới Hạn Cược Xác lập không tồn tại.",
  basketball_update_interval_violated: "Bóng Rổ Cập nhật vi phạm khoảng.",
  tennis_bet_limit_setting_not_exists:"Quần Vợt Giới Hạn Cược Xác lập không tồn tại.",
  tennis_update_interval_violated: "Quần Vợt Update interval violated.",
  baseball_bet_limit_setting_not_exists:"Bóng Chày Giới Hạn Cược Xác lập không tồn tại.",
  baseball_update_interval_violated: "Bóng Chày Cập nhật vi phạm khoảng.",
  parlay_bet_limit_setting_not_exists:"Đặt Cựơc Dồn Giới Hạn Cược Xác lập không tồn tại.",
  parlay_update_interval_violated: "Đặt Cựơc Dồn Cập nhật vi phạm khoảng.",
  esports_bet_limit_setting_not_exists:"Thể thao điện tử Giới Hạn Cược Xác lập không tồn tại.",
  esports_update_interval_violated: "Thể thao điện tử Cập nhật vi phạm khoảng.",
  others_bet_limit_setting_not_exists:"Thể loại khác Giới Hạn Cược Xác lập không tồn tại.",
  others_update_interval_violated: "Thể loại khác Cập nhật vi phạm khoảng.",
  soccer_parent_bet_limit_setting_not_exists: "Bóng Đá đại lý tuyến trên Cược Giới Hạn Xác lập không tồn tại.",
  soccer_min_bet_lt_parent: "Bóng Đá Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  soccer_max_bet_gt_parent: "Bóng Đá Đặt Cược Tối Đa Vượt quá đại lý tuyến trên.",
  soccer_max_per_match_gt_parent: "Bóng Đá Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  basketball_parent_bet_limit_setting_not_exists: "Bóng Rổ parent đại lý tuyến trên Cược Giới Hạn Xác lập không tồn tại.",
  basketball_min_bet_lt_parent: "Bóng Rổ Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  basketball_max_bet_gt_parent: "Bóng Rổ Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  basketball_max_per_match_gt_parent: "Bóng Rổ Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  tennis_parent_bet_limit_setting_not_exists: "Quần Vợt đại lý tuyến trên Cược Giới Hạn Xác lập không tồn tại.",
  tennis_min_bet_lt_parent: "Quần Vợt Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  tennis_max_bet_gt_parent: "Quần Vợt Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  tennis_max_per_match_gt_parent: "Quần Vợt Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  baseball_parent_bet_limit_setting_not_exists: "Bóng Chày đại lý tuyến trên Cược Giới Hạn Xác lập không tồn tại.",
  baseball_min_bet_lt_parent: "Bóng Chày Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  baseball_max_bet_gt_parent: "Bóng Chày Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  baseball_max_per_match_gt_parent: "Bóng Chày Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  parlay_parent_bet_limit_setting_not_exists: "Đặt Cựơc Dồn đại lý tuyến trên Cược Giới Hạn Xác lập không tồn tại.",
  parlay_min_bet_lt_parent: "Đặt Cựơc Dồn Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  parlay_max_bet_gt_parent: "Đặt Cựơc Dồn Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  parlay_max_per_match_gt_parent: "Đặt Cựơc Dồn Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  esports_parent_bet_limit_setting_not_exists: "Thể thao điện tử đại lý tuyến trên Cược Giới Hạn Xác lập không tồn tại.",
  esports_min_bet_lt_parent: "Thể thao điện tử Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  esports_max_bet_gt_parent: "Thể thao điện tử Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  esports_max_per_match_gt_parent: "Thể thao điện tử Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  others_parent_bet_limit_setting_not_exists: "Thể loại khác đại lý tuyến trên Cược Giới Hạn Xác lập không tồn tại.",
  others_min_bet_lt_parent: "Thể loại khác Đặt cược tối thiểu Thấp đại lý tuyến trên.",
  others_max_bet_gt_parent: "Thể loại khác Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  others_max_per_match_gt_parent: "Thể loại khác Tối Đa Cho Mỗi Trận quá đại lý tuyến trên.",
  update_interval_violated: "Cập nhật vi phạm khoảng.",
  exceeded_parent_others: "Hoa Hồng đại lý Vượt quá.",
  exceeded_parent_hdp: "HDP đại lý Vượt quá.",
  no_information_available: "Không có tin.",
  request_processing: "Yêu cầu gia công...",
  new_login_id_format_error: "Chỉ cho phép các ký tự chữ thường và số từ a đến z và 0 đến 9.",
  account_id_format_error: "Chỉ cho phép các ký tự chữ thường và số từ a đến z và 0 đến 9.",
  inactive_account: "Tài Khoản Đã đóng / Bị treo giò. Liên hệ.",

  sportsbook_account_pt_gt_92: "Phần thầu của Super Senior không thể lớn hơn 92%",
  pending_result: "Kết quả chờ xử lý",
  insufficient_balance: "Thiếu cân bằng",
  ok: "Hoàn thành",
  settlement_warning: "Cảnh báo: nếu số dư được chuyển hoàn toàn, các thành viên được đánh dấu bên dưới sẽ có tín dụng đặt cược âm và do đó, họ có thể mất nhiều hơn tín dụng đã cho.",
  jackpot_alert: "Đối với bất kỳ khoản thanh toán jackpot lũy tiến nào vượt quá 100.000 MYR (1.000.000 THB), WBET sẽ chịu chi phí cho toàn bộ số tiền.",
  accumulate_alert: "Giới hạn thắng sẽ được đặt lại sau khi danh sách hoàn tiền về đã được giải quyết.",
  filter_yesterday_balance: "Hiển thị Số dư ngày hôm qua không bằng 0",

  soccer_hdp_account_pt_lt_downline: "[Soccer] HDP Account PT is lower than downline",
  soccer_1x2_account_pt_lt_downline: "[Soccer] 1X2 Account PT is lower than downline",
  soccer_others_account_pt_lt_downline: "[Soccer] Others Account PT is lower than downline",
  soccer_hdp_exceeded_parent_pt: "[Soccer] Exceeded parent HDP PT setting.",
  soccer_1x2_exceeded_parent_pt: "[Soccer] Exceeded parent 1X2 PT setting.",
  soccer_others_exceeded_parent_pt: "[Soccer] Exceeded parent OTHERS PT setting.",
  parlay_account_pt_lt_downline: "[Parlay] Account PT is lower than downline",
  account_pt_lt_downline: "Account PT is lower than downline",
  player_alert_tooltips: "(Lưu ý: Chỉ hiển thị thành viên có tín dụng dưới mức cược tối thiểu.)",

  relogin_seconds: "Vui lòng đăng nhập lại sau {timer} giây",
  relogin_hours: "Vui lòng đăng nhập lại sau {timer} giờ",
  relogin_tooltips: "Nếu bạn cần hỗ trợ mở khóa tài khoản, vui lòng liên hệ bộ phận hỗ trợ khách hàng của chúng tôi.",
  last_modified_slot: "Lần sửa đổi cuối cùng của bạn là {oldTime}. Vui lòng thử lại vào {newTime}.",

  account_min_gt_pt: "Account minimum PT setting is greater than parent PT setting.",
  account_min_required: "Account minimum PT setting is required.",
  account_pt_required: "Account PT setting is required.",
  agent_id_required: "Agent ID is required.",
  amount_required: "Amount is required.",
  at_least_one_schedule_required: "At least one schedule setting is required.",
  authority_option_required: "Authority option setting is required.",

  baseball_min_bet_gt_max_bet: "Baseball min bet greater than max bet.",
  baseball_max_bet_gt_max_per_match: "Baseball max bet greater than max per match.",
  basketball_max_bet_gt_max_per_match: "Basketball max bet greater than max per match.",
  basketball_min_bet_gt_max_bet: "Basketball min bet greater than max bet.",
  brand_name_required: "Brand name is required",
  client_ip_required: "Client IP is required",

  cockfight_bet_limit_exists: "[ESports2] Bet limit is already exists.",
  cockfight_bet_limit_packages_required: "[ESports2] Bet limit packages are required.",
  cockfight_commission_required: "[ESports2] Commission setting is required.",
  cockfight_commission_setting_exists: "[ESports2] Commission setting is exists.",
  cockfight_invalid_bet_limit_package: "[ESports2] Invalid bet limit packages.",
  cockfight_member_bet_limit_package_gt_one: "[ESports2] Member bet limit packages is more than one.",
  cockfight_parent_bet_limit_not_exists: "[ESports2] Parent bet limit does not exists.",
  cockfight_parent_commission_not_exists: "[ESports2] Parent commission does not exists.",

  credit_limit_gt_parent_member_credit_limit: "Credit limit greater than parent member credit limit.",
  downline_limit_exceeded: "Downline limit exceeed.",

  esports_max_bet_gt_max_per_match: "ESports max bet greater than max per match.",
  esports_min_bet_gt_max_bet: "ESports min bet greater than max bet.",

  exceeded_parent_parlay_a: "Exceeded parent parlay A PT setting.",
  exceeded_parent_parlay_b: "Exceeded parent parlay B PT setting.",
  exceeded_parent_pt: "Exceeded parent parlay PT setting.",

  hdp_account_min_gt_pt: "HDP account min greater than parent PT.",
  hdp_account_min_required: "HDP account min setting is required.",
  hdp_account_pt_required: "HDP account PT setting is required.",
  hdp_exceeded_parent_commission: "HDP exceeded parent commission.",
  hdp_exceeded_parent_pt: "HDP exceeded parent PT.",
  hdp_mmo_account_min_gt_pt: "HDP MMO account min greater than parent PT.",
  hdp_mmo_account_min_required: "HDP MMO account min setting is required.",
  hdp_mmo_account_pt_required: "HDP MMO account PT setting is required.",
  hdp_mmo_commission_required: "HDP MMO commission is required.",
  hdp_mmo_exceeded_parent_commission: "HDP MMO exceeded parent commission.",
  hdp_mmo_exceeded_parent_pt: "HDP MMO exceeded parent PT.",
  hdp_mmo_parent_min_not_meet: "HDP MMO does not match with parent minimum PT.",
  hdp_mmo_parent_pt_not_exists: "HDP MMO parent PT setting does not exists.",
  hdp_mmo_pt_setting_exists: "HDP MMO PT setting is exists.",
  hdp_mmo_upline_pt_required: "HDP MMO Upline PT setting is required.",
  hdp_mmo_upline_remaining_gt_account_pt: "HDP MMO Upline remaining PT setting is greater than account PT setting.",
  hdp_mmo_upline_remaining_required: "HDP MMO Upline remaining PT setting is required.",
  hdp_package_required: "HDP packages is required.",
  hdp_packages_not_exists: "HDP packages does not exists.",
  hdp_packages_required: "HDP packages is required.",
  hdp_parent_min_not_meet: "HDP does not match with parent minimum PT.",
  hdp_parent_pt_not_exists: "HDP parent PT setting does not exists.",
  hdp_pt_setting_exists: "HDP PT setting is exists.",
  hdp_required: "HDP is required.",
  hdp_upline_pt_required: "HDP Upline PT setting is required.",
  hdp_upline_remaining_gt_account_pt: "HDP Upline remaining PT setting is greater than account PT setting.",
  hdp_upline_remaining_required: "HDP Upline remaining PT setting is required.",

  inactive_profile: "Inactive profile.",
  incorrect_format: "Incorrect format.",
  invalid_amount: "Invalid amount.",
  invalid_baseball_max_bet: "Invalid baseball max bet.",
  invalid_baseball_max_per_match: "Invalid baseball max per match.",
  invalid_baseball_min_bet: "Invalid baseball min bet.",
  invalid_basketball_max_bet: "Invalid basketball max bet,",
  invalid_basketball_max_per_match: "Invalid basketball max per match.",
  invalid_basketball_min_bet: "Invalid basketball min bet.",
  invalid_esports_max_bet: "Invalid Esports max bet.",
  invalid_esports_max_per_match: "Invalid Esports max per match.",
  invalid_esports_min_bet: "Invalid Esports min bet.",
  invalid_method: "Invalid method.",
  invalid_others_max_bet: "Invalid others max bet.",
  invalid_others_max_per_match: "Invalid others max per match.",
  invalid_others_min_bet: "Invalid others min bet.",
  invalid_parlay_max_bet: "Invalid parlay max bet.",
  invalid_parlay_max_per_match: "Invalid parlay max per match.",
  invalid_parlay_min_bet: "Invalid parlay min bet.",
  invalid_soccer_max_bet: "Invalid soccer max bet.",
  invalid_soccer_max_per_match: "Invalid soccer max per match.",
  invalid_soccer_min_bet: "Invalid soccer min bet.",
  invalid_tennis_max_bet: "Invalid tennis max bet.",
  invalid_tennis_max_per_match: "Invalid tennis max per match.",
  invalid_tennis_min_bet: "Invalid tennis min bet.",

  keno_bet_limit_exists: "[Keno] Bet limit is already exists.",
  keno_bet_limit_packages_required: "[Keno] Bet limit packages are required.",
  keno_commission_required: "[Keno] Commission setting is required.",
  keno_commission_setting_exists: "[Keno] Commission setting is exists.",
  keno_exceeded_parent_commission: "[Keno] Account commission setting is greater than parent commission setting.",
  keno_invalid_bet_limit_package: "[Keno] Invalid bet limit packages.",
  keno_member_bet_limit_package_gt_one: "[Keno] Member bet limit packages is more than one.",
  keno_parent_bet_limit_not_exists: "[Keno] Parent bet limit does not exists.",
  keno_parent_commission_not_exists: "[Keno] Parent commission does not exists.",

  livecasino_account_min_gt_pt: "[Livecasino] Account minimum PT setting is greater than parent PT setting.",
  livecasino_bet_limit_exists: "[Livecasino] Bet limit is already exists.",
  livecasino_bet_limit_packages_required: "[Livecasino] Bet limit packages are required.",
  livecasino_commission_required: "[Livecasino] Commission setting is required.",
  livecasino_commission_setting_exists: "[Livecasino] Commission setting is exists.",
  livecasino_exceeded_parent_commission: "[Livecasino] Account commission setting is greater than parent commission setting.",
  livecasino_invalid_bet_limit_package: "[Livecasino] Invalid bet limit packages.",
  livecasino_member_bet_limit_package_gt_one: "[Livecasino] Member bet limit packages is more than one.",
  livecasino_parent_bet_limit_not_exists: "[Livecasino] Parent bet limit does not exists.",
  livecasino_parent_commission_not_exists: "[Livecasino] Parent commission does not exists.",

  login_ip_required: "Login IP is required.",
  lottery_1d_parent_min_not_meet: "[Lottery 1D] Does not match with parent minimum PT.",
  lottery_1d_account_min_gt_pt: "[Lottery 1D] Account minimum PT setting is greater than parent PT setting.",
  lottery_1d_account_min_required: "[Lottery 1D] Account minimum PT setting is required.",
  lottery_1d_account_pt_lt_downline: "[Lottery 1D] Account PT is lower than downline.",
  lottery_1d_account_pt_required: "[Lottery 1D] Account PT setting is required.",
  lottery_1d_commission_required: "[Lottery 1D] Commission setting is required.",
  lottery_1d_exceeded_parent_comm: "[Lottery 1D] Account commission setting is greater than parent commission setting.",
  lottery_1d_exceeded_parent_commission: "[Lottery 1D] Account commission setting is greater than parent commission setting.",
  lottery_1d_exceeded_parent_pt: "[Lottery 1D] Exceeded parent PT setting.",
  lottery_1d_pt_setting_exists: "[Lottery 1D] Parent PT setting is exists.",
  lottery_1d_parent_pt_not_exists: "[Lottery 1D] Parent PT setting does not exists.",
  lottery_1d_pt_setting_not_exists: "[Lottery 1D] PT setting does not exists.",
  lottery_1d_upline_pt_required: "[Lottery 1D] Upline PT setting is required.",
  lottery_1d_upline_remaining_gt_account_pt: "[Lottery 1D] Upline remaining PT setting is greater than account PT setting.",
  lottery_1d_upline_remaining_required: "[Lottery 1D] Upline remaining PT setting is required.",

  lottery_2d_account_min_gt_pt: "[Lottery 2D] Account minimum PT setting is greater than parent PT setting.",
  lottery_2d_account_min_required: "[Lottery 2D] Account minimum PT setting is required.",
  lottery_2d_account_pt_lt_downline: "[Lottery 2D] Account PT is lower than downline.",
  lottery_2d_account_pt_required: "[Lottery 2D] Account PT setting is required.",
  lottery_2d_commission_required: "[Lottery 2D] Commission setting is required.",
  lottery_2d_exceeded_parent_comm: "[Lottery 2D] Account commission setting is greater than parent commission setting.",
  lottery_2d_exceeded_parent_commission: "[Lottery 2D] Account commission setting is greater than parent commission setting.",
  lottery_2d_exceeded_parent_pt: "[Lottery 2D] Exceeded parent PT setting.",
  lottery_2d_parent_min_not_meet: "[Lottery 2D] Does not match with parent minimum PT.",
  lottery_2d_parent_pt_not_exists: "[Lottery 2D] Parent PT setting does not exists.",
  lottery_2d_pt_setting_exists: "[Lottery 2D] Parent PT setting is exists.",
  lottery_2d_pt_setting_not_exists: "[Lottery 1D] PT setting does not exists.",
  lottery_2d_upline_pt_required: "[Lottery 2D] Upline PT setting is required.",
  lottery_2d_upline_remaining_gt_account_pt: "[Lottery 2D] Upline remaining PT setting is greater than account PT setting.",
  lottery_2d_upline_remaining_required: "[Lottery 2D] Upline remaining PT setting is required.",

  lottery_3d_commission_required: "[Lottery 3D] Commission setting is required.",
  lottery_3d_exceeded_parent_comm: "[Lottery 3D] Account commission setting is greater than parent commission setting.",
  lottery_3d_exceeded_parent_commission: "[Lottery 3D] Account commission setting is greater than parent commission setting.",
  lottery_4d_commission_required: "[Lottery 4D] Commission setting is required.",
  lottery_4d_exceeded_parent_comm: "[Lottery 4D] Account commission setting is greater than parent commission setting.",
  lottery_4d_exceeded_parent_commission: "[Lottery 4D] Account commission setting is greater than parent commission setting.",
  lottery_bet_limit_exists: "[Lottery] Bet limit is already exists.",
  lottery_bet_limit_packages_required: "[Lottery] Bet limit packages are required.",
  lottery_commission_setting_exists: "[Lottery] Commission setting is exists.",
  lottery_invalid_bet_limit_package: "[Lottery] Invalid bet limit packages.",
  lottery_member_bet_limit_package_gt_one: "[Lottery] Member bet limit packages is more than one.",
  lottery_parent_bet_limit_not_exists: "[Lottery] Parent bet limit does not exists.",
  lottery_parent_commission_not_exists: "[Lottery] Parent commission does not exists.",

  lotto_bet_limit_exists: "[Lotto] Bet limit is already exists.",
  lotto_bet_limit_packages_required: "[Lotto] Bet limit packages are required.",
  lotto_commission_required: "[Lotto] Commission setting is required.",
  lotto_commission_setting_exists: "[Lotto] Commission setting is exists.",
  lotto_exceeded_parent_commission: "[Lotto] Account commission setting is greater than parent commission setting.",
  lotto_invalid_bet_limit_package: "[Lotto] Invalid bet limit packages.",
  lotto_member_bet_limit_package_gt_one: "[Lotto] Member bet limit packages is more than one.",
  lotto_parent_bet_limit_not_exists: "[Lotto] Parent bet limit does not exists.",
  lotto_parent_commission_not_exists: "[Lotto] Parent commission does not exists.",

  method_required: "Method is required.",
  no_accumulate_win: "No accumulated win.",

  one_x_two_account_min_gt_pt: "[1X2] Account minimum PT setting is greater than parent PT setting.",
  one_x_two_account_min_required: "[1X2] Account minimum PT setting is required.",
  one_x_two_account_pt_required: "[1X2] Account PT setting is required.",
  one_x_two_commission_required: "[1X2] Commission setting is required.",
  one_x_two_exceeded_parent_commission: "[1X2] Account commission setting is greater than parent commission setting.",
  one_x_two_exceeded_parent_pt: "[1X2] Exceeded parent PT setting.",
  one_x_two_parent_min_not_meet: "[1X2] Does not match with parent minimum PT.",
  one_x_two_parent_pt_not_exists: "[1X2] Parent PT setting does not exists.",
  one_x_two_pt_setting_exists: "[1X2] PT setting does not exists.",
  one_x_two_upline_pt_required: "[1X2] Upline PT setting is required.",
  one_x_two_upline_remaining_gt_account_pt: "[1X2] Upline remaining PT setting is greater than account PT setting.",
  one_x_two_upline_remaining_required: "[1X2] Upline remaining PT setting is required.",

  others_account_min_gt_pt: "[Others] Account minimum PT setting is greater than parent PT setting.",
  others_account_min_required: "[Others] Account minimum PT setting is required.",
  others_account_pt_required: "[Others] Account PT setting is required.",
  others_exceeded_parent_commission: "[Others] Account commission setting is greater than parent commission setting.",
  others_exceeded_parent_pt: "[Others] Exceeded parent PT setting.",
  others_max_bet_gt_max_per_match: "[Others] Max bet is greater than max per match,",
  others_min_bet_gt_max_bet: "[Others] Min bet greater than max bet.",
  others_parent_min_not_meet: "[Others] Does not match with parent minimum PT.",
  others_parent_pt_not_exists: "[Others] Parent PT setting does not exists.",
  others_pt_setting_exists: "[Others] PT setting does not exists.",
  others_upline_pt_required: "[Others] Upline PT setting is required.",
  others_upline_remaining_gt_account_pt: "[Others] Upline remaining PT setting is greater than account PT setting.",
  others_upline_remaining_required: "[Others] Upline remaining PT setting is required.",

  parent_hdp_packages_not_exists: "HDP packages does not exists.",
  parent_pt_not_exists: "Parent PT setting does not exists.",
  parent_setting_not_exists: "PT setting does not exists.",
  parlay_a_commission_required: "[Parlay A] Commission setting is required.",
  parlay_a_exceeded_parent_commission: "[Parlay A] Account commission setting is greater than parent commission setting.",
  parlay_a_required: "[Parlay A] Setting is required.",
  parlay_account_min_gt_pt: "[Parlay] Account minimum PT setting is greater than parent PT setting.",
  parlay_account_min_required: "[Parlay] Account minimum PT setting is required.",
  parlay_account_pt_required: "[Parlay] Account PT setting is required.",
  parlay_b_commission_required: "[Parlay B] Commission setting is required.",
  parlay_b_exceeded_parent_commission: "[Parlay B] Account commission setting is greater than parent commission setting.",
  parlay_b_required: "[Parlay B] Setting is required.",
  parlay_exceeded_parent_pt: "[Parlay] Exceeded parent PT setting.",
  parlay_max_bet_gt_max_per_match: "[Parlay] Max bet greater than max per match.",
  parlay_min_bet_gt_max_bet: "[Parlay] Min bet greater than max bet.",
  parlay_mmo_account_min_gt_pt: "[Parlay MMO] Account minimum PT setting is greater than parent PT setting.",
  parlay_mmo_account_min_required: "[Parlay MMO] Account minimum PT setting is required.",
  parlay_mmo_account_pt_required: "[Parlay MMO] Account PT setting is required.",
  parlay_mmo_exceeded_parent_pt: "[Parlay MMO] Exceeded parent PT setting.",
  parlay_mmo_parent_min_not_meet: "[Parlay MMO] Does not match with parent minimum PT.",
  parlay_mmo_parent_pt_not_exists: "[Parlay MMO] Parent PT setting does not exists.",
  parlay_mmo_pt_setting_exists: "[Parlay MMO] PT setting does not exists.",
  parlay_mmo_upline_pt_required: "[Parlay MMO] Upline PT setting is required.",
  parlay_mmo_upline_remaining_gt_account_pt: "[Parlay MMO] Upline remaining PT setting is greater than account PT setting.",
  parlay_mmo_upline_remaining_required: "[Parlay MMO] Upline remaining PT setting is required.",
  parlay_parent_min_not_meet: "[Parlay] Does not match with parent minimum PT.",
  parlay_parent_pt_not_exists: "[Parlay] Parent PT setting does not exists.",
  parlay_pt_setting_exists: "[Parlay] PT setting does not exists.",
  parlay_pt_setting_not_exists: "[Parlay] PT setting does not exists.",
  parlay_upline_pt_required: "[Parlay] Upline PT setting is required.",
  parlay_upline_remaining_gt_account_pt: "[Parlay] Upline remaining PT setting is greater than account PT setting.",
  parlay_upline_remaining_required: "[Parlay] Upline remaining PT setting is required.",
  platform_code_required: "Platform code is required.",
  platform_name_required: "Platform name is required.",
  pt_setting_not_exists: "PT setting does not exists.",

  result_id_required: "Result ID is required.",
  schedule_not_exists: "Schedule does not exists.",

  slots_commission_required: "[Slots] Commission setting is required.",
  slots_commission_setting_exists: "[Slots] Commission setting is exists.",
  slots_exceeded_parent_commission: "[Slots] Account commission setting is greater than parent commission setting.",
  slots_parent_commission_not_exists: "[Slots] Parent commission does not exists.",

  soccer_1x2_account_min_gt_pt: "[1X2] Account minimum PT setting is greater than parent PT setting.",
  soccer_1x2_account_min_required: "[1X2] Account minimum PT setting is required.",
  soccer_1x2_account_pt_required: "[1X2] Account PT setting is required.",
  soccer_1x2_parent_pt_not_exists: "[1X2] Parent PT setting does not exists.",
  soccer_1x2_pt_setting_not_exists: "[1X2] PT setting does not exists.",
  soccer_1x2_upline_pt_required: "[1X2] Upline PT setting is required.",
  soccer_1x2_upline_remaining_gt_account_pt: "[1X2] Upline remaining PT setting is greater than account PT setting.",
  soccer_1x2_upline_remaining_required: "[1X2] Upline remaining PT setting is required.",
  soccer_hdp_account_min_gt_pt: "[HDP] Account minimum PT setting is greater than parent PT setting.",
  soccer_hdp_account_min_required: "[HDP] Account minimum PT setting is required.",
  soccer_hdp_account_pt_required: "[HDP] Account PT setting is required.",
  soccer_hdp_parent_pt_not_exists: "[HDP] Parent PT setting does not exists.",
  soccer_hdp_pt_setting_not_exists: "[HDP] PT setting does not exists.",
  soccer_hdp_upline_pt_required: "[HDP] Upline PT setting is required.",
  soccer_hdp_upline_remaining_gt_account_pt: "[HDP] Upline remaining PT setting is greater than account PT setting.",
  soccer_hdp_upline_remaining_required: "[HDP] Upline remaining PT setting is required.",
  soccer_max_bet_gt_max_per_match: "[Soccer] Max bet greater than max per match.",
  soccer_min_bet_gt_max_bet: "[Soccer] Min bet greater than max bet.",
  soccer_others_account_min_gt_pt: "[Others] Account minimum PT setting is greater than parent PT setting.",
  soccer_others_account_min_required: "[Others] Account minimum PT setting is required.",
  soccer_others_account_pt_required: "[Others] Account PT setting is required.",
  soccer_others_parent_pt_not_exists: "[Others] Parent PT setting does not exists.",
  soccer_others_pt_setting_not_exists: "[Others] PT setting does not exists.",
  soccer_others_upline_pt_required: "[Others] Upline PT setting is required.",
  soccer_others_upline_remaining_gt_account_pt: "[Others] Upline remaining PT setting is greater than account PT setting.",
  soccer_others_upline_remaining_required: "[Others] Upline remaining PT setting is required.",

  sportsbook_commission_setting_exists: "[Sportsbook] Commission setting is exists.",
  sportsbook_mmo_commission_setting_exists: "[Sportsbook MMO] Commission setting is exists.",
  sportsbook_mmo_parent_commission_not_exists: "[Sportsbook MMO] Parent commission setting does not exists.",
  sportsbook_parent_commission_not_exists: "[Sportsbook] Parent ommission setting does not exists.",
  status_required: "Status is required.",
  sub_not_exists: "Sub-account does not exists.",

  target_profile_id_required: "Target profile ID is required.",
  tennis_max_bet_gt_max_per_match: "[Tennis] Max bet greater than max per match.",
  tennis_min_bet_gt_max_bet: "[Tennis] Min bt greater than max bet.",
  tournament_commission_required: "Tournament commission is required.",
  tournament_commission_setting_exists: "Tournament commission setting is exists.",
  tournament_exceeded_parent_commission: "Tournament parent commission exceeeded.",
  tournament_parent_commission_not_exists: "Tournament parent commission does not exits.",

  upline_pt_required: "Upline PT setting is required.",
  upline_remaining_gt_account_pt: "Upline remaining PT setting is greater than account PT setting.",
  upline_remaining_required: "Upline remaining PT setting is required.",
  wallet_not_exists: "Wallet does not exists.",
  working_date_required: "Working date is required.",
  password_expired_alert: "Mật khẩu của bạn đã hết hạn. Vui lòng đặt lại mật khẩu của bạn.",

  cs_min_bet_lt_soccer: "Minimum bet is lower than soccer minimum bet.",
  cs_max_bet_gt_soccer: "Maximum bet is greater than soccer maximum bet.",
  cs_max_per_match_gt_soccer: "Maximum bet per match is greater than soccer match per match.",
  cs_tooltips: "Giới hạn đặt cược tỷ số chính xác chỉ tuân theo giới hạn đặt cược bóng đá",

  contact_phone_format_error: "Định dạng số điện thoại liên hệ không hợp lệ",
  contact_email_format_error: "Định dạng email liên hệ không hợp lệ",

  "notice": "<div style='text-align: left;'><b><u>Thông báo: Cập nhật về Giới hạn Cược tại Evolution Casino</u></b><br><br>Kính gửi Quý Đại lý,<br><br>Chúng tôi xin thông báo rằng, bắt đầu từ ngày 31 tháng 1 năm 2025, <b>Evolution Casino sẽ không hỗ trợ giới hạn cược do công ty áp đặt nữa</b>. Thay đổi này có nghĩa là nền tảng sẽ không hạn chế số tiền cược, giúp hoạt động linh hoạt hơn.<br><br>Chúng tôi đánh giá cao sự hiểu biết và hợp tác liên tục của quý vị trong việc thích nghi với sự thay đổi này. Nếu có bất kỳ câu hỏi nào, vui lòng liên hệ với đội ngũ hỗ trợ của chúng tôi.<br><br>Xin cảm ơn sự hợp tác của quý vị.</div>"

};
